import Service, { inject as service } from '@ember/service';
import config from 'sh-www/config/environment';
import { loadScript } from 'sh-www/utils/script-loader';

class FacebookProviderService extends Service {
  @service('error-tracker') errorTracker;

  #facebookPromise = null;
  #facebook = null;

  get facebook() {
    return this.#facebook;
  }

  load() {
    return this.#facebookPromise ??= loadScript('https://connect.facebook.net/en_US/sdk.js')
    .then(() => {
      FB.init({
        appId            : config.FACEBOOK_APP_ID,
        autoLogAppEvents : true,
        xfbml            : true,
        version          : 'v3.2'
      });
    })
    .catch((e) => {
      this.errorTracker.error(e, this, 'Unable to load Facebook SDK');
      throw e;
    });
  }

  /**
   * Show the FB Share dialog
   *
   * @param {String} url          URL of page to share
   * @param {String=} opt_quote   String for the description.
   */
  showShareDialog(url, opt_quote) {
    const fbParams = { method: 'share', href: url };

    if (opt_quote) {
      fbParams['quote'] = opt_quote;
    }

    this.load().then(() => {
      FB.ui(fbParams, function() {});
    });
  }
}

export default FacebookProviderService;
